import { Reveal } from "../Reveal";

const testimonials = [
  { img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NjMwMjkwNXww&ixlib=rb-4.1.0&q=85",
    name: "Priya Nair", role: "Senior SWE → Staff Engineer, FAANG",
    quote: "Joy rewrote my resume and it was like reading about someone far more impressive than I felt. Three interviews in ten days." },
  { img: "https://images.unsplash.com/photo-1676989880361-091e12efc056?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NjMwMjkwNXww&ixlib=rb-4.1.0&q=85",
    name: "Marcus Reed", role: "Product Lead, fintech",
    quote: "The consulting sessions reframed how I talk about impact. I negotiated a 28% bump on my last offer." },
];

export default function Testimonials() {
  return (
    <section className="bg-secondary/50 py-28 lg:py-36" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-16">
          <span className="overline text-cobalt">Proof</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-navy mt-4">
            Results that <span className="italic">speak.</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure className="bg-white border border-border p-8 lg:p-10 h-full flex flex-col">
                <blockquote className="font-display text-2xl lg:text-3xl leading-snug text-navy">“{t.quote}”</blockquote>
                <figcaption className="mt-8 flex items-center gap-4">
                  <img src={t.img} alt={t.name} className="w-14 h-14 object-cover rounded-full border border-border" />
                  <div>
                    <p className="font-semibold text-navy">{t.name}</p>
                    <p className="text-sm text-slateink">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
